<template>
  <div class="Wdgt-Auth-Module">
    <TelegramAuth class="Wdgt-Auth-Module__social-btn" />
    <p class="Wdgt-Auth-Module__separator">или Войти с помощью</p>
    <GoogleAuth class="Wdgt-Auth-Module__social-btn" />
    <ButtonSocial class="Wdgt-Auth-Module__social-btn" :text="'Электронная почта'" @click="toGoToLoginForm"/>
    <p class="Wdgt-Auth-Module__ftr-txt">
      Нет аккаунта? <button class="Wdgt-Auth-Module__lnk" @click="toOpenSignupSection">Зарегистрироваться</button>
    </p>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //------------------------------
  import GoogleAuth from '@widgets/Authorization/components/GoogleAuth/GoogleAuth.vue';
  import TelegramAuth from "@widgets/Authorization/components/TelegramAuth/TelegramAuth2.vue";
  import ButtonSocial from '@shared/UI/Buttons/ButtonSocial/ButtonSocial';
  //----------------------------
  const store = useStore();
  //------------------------------
  //Открыть стартовую секцию регистрации
  const toOpenSignupSection = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_SIGNUP);
  }
  //Открыть форму логина
  const toGoToLoginForm = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.LOGIN_FORM);
  }
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
